import { Component } from "react"
import BaseModal, { ModalActions, SaveButton, CancelButton, DeleteButton } from "../../../../containers/UI/Modal/BaseModal"
import InputRow from "../../../configuration/Rows/InputRow/InputRow"
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow"
import axios from "../../../../axios"


class BookingModal extends Component {

  state = {
    booking: {},
    orderOptions: [],
    valuesChanged: false,
  }

  componentDidMount() {

    let booking = this.props.selectedBooking
    
    // Create if necessary
    if (!booking) {
      booking = { 
        date: new Date() / 1000,
        direction: "out",
        amount: "",
        party: "",
        description: ""
      }
    }

    // Change dot to comma
    if (booking.amount) {
      booking.amount = booking.amount.toLocaleString("be-NL")
    }
    // Parse date
    if (booking.date) {
      booking.date = new Date(booking.date * 1000).toLocaleDateString("en-GB")
    }

    // Update state
    this.setState({ booking: {...booking} })

    // Load orders
    axios.get("/orders/allReduced").then(response => {
      if (response.data) {

         // Save into state
        this.setState({ 
          orderOptions: response.data.map(order => ({ value: order._id, label: order.customer.name + " - " + order.internalReference + " - €" + order.totalAmount.toLocaleString("DE-de")}))
        })
      }
    })
  }


  saveHandler = () => {

    if (this.state.valuesChanged) {

      // Error-checking
      let booking = this.state.booking

      if (!booking.amount && booking.amount !== 0) {
        return alert("Please enter an amount.")
      }

      let parts = booking.date ? booking.date.split("/") : []
      if (parts.length !== 3) {
        return alert("Please enter a valid date.")
      }

      // Convert European date to JavaScript date
      let date = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
      booking.date = date.getTime() / 1000
      booking.financialYear = date.getFullYear()

      // Replace comma with decimal point
      booking.amount = booking.amount ? booking.amount.replace(/,/g, '.') : 0

      // If incoming, clear order reference
      if (booking.direction === "out") {
        booking.order = null
      }

      // Sync to the backend
      axios.post("/financial-bookings/update", booking)
    }

    // Close the modal view
    this.props.closeModal()
  }

   deleteHandler = () => {

    // Sync to the backend
    axios.delete("/financial-bookings/delete/" + this.state.booking._id)

    // Close the modal view
    this.props.closeModal()
  }

  updateProperty(property, value) {
    let booking = {...this.state.booking}
    booking[property] = value
    this.setState({ booking, valuesChanged: true })
  }


  render() {

    let createMode = !(this.props.selectedBooking)

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={createMode ? "Nieuwe boeking" : "Boeking aanpassen"}
      >
        <SelectRow
          title="Richting"
          firstRow ultrawide increasedPadding
          value={this.state.booking.direction}
          onChange={(newValue) => this.updateProperty("direction", newValue.value)}
          options={[{ value: "out", label: "Uitgaand" }, { value: "in", label: "Inkomend" }]}/>
        <SelectRow
          title="Order" ultrawide increasedPadding
          show={this.state.booking.direction === "in"}
          value={this.state.booking.order}
          onChange={(el) => this.updateProperty("order", el.value)}
          options={this.state.orderOptions}/>
        <InputRow
          title="Datum"
          enabled ultrawide
          value={this.state.booking.date ?? ""}
          placeholder={"E.g. 15/01/2024"}
          onChange={(event) => this.updateProperty("date", event.target.value)}/>
        <InputRow
          title="Bedrag"
          enabled ultrawide
          value={this.state.booking.amount ?? ""}
          placeholder={"E.g. 500"}
          onChange={(event) => this.updateProperty("amount", event.target.value)}/>
        <InputRow
          title="Partij"
          enabled ultrawide
          value={this.state.booking.party ?? ""}
          placeholder={"E.g. Victoria Bohn"}
          onChange={(event) => this.updateProperty("party", event.target.value)}/>
        <InputRow
          title="Beschrijving"
          enabled ultrawide
          value={this.state.booking.description ?? ""}
          placeholder={"E.g. Loon december 2025"}
          onChange={(event) => this.updateProperty("description", event.target.value)}/>

        <ModalActions>
          {(this.state.valuesChanged || createMode) ? (
            <>
              <CancelButton onClick={this.props.closeModal}/>
              {!createMode && <DeleteButton onClick={this.deleteHandler}/>}
              <SaveButton onClick={this.saveHandler}>
                {createMode ? "Upload" : "Save"}
              </SaveButton>
            </>
          ) : (
            <>
              <CancelButton onClick={this.saveHandler}>Close</CancelButton>
              {!createMode && <DeleteButton onClick={this.deleteHandler}/>}
            </>
          )}
        </ModalActions>
      </BaseModal>
    )
  }
}

export default BookingModal
